/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';

export const WhitelistAddExternalComponent = ({ children }) => (
  <div className="pt-2 pb-3 px-3 mb-3  rounded bg-light">{children}</div>
);

WhitelistAddExternalComponent.propTypes = {
  children: PropTypes.func.isRequired,
};
